import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { api } from '../../api';
import HeadComponent from '../../head';
import Swal from 'sweetalert2';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    phone: '',
    budget: '',
    company: '',
    metrics: '',
  });

  const [responseMessage, setResponseMessage] = useState('');
  const [data, setData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);




  useEffect(() => {
    api.get('/contacts/CreateContact')
      .then(response => setData(response.data))
      .catch(error => console.log(error));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


   const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await api.post('/contacts/CreateContact', formData);
      
     Swal.fire({
  title: 'Message Received!',
  text: 'Thank you for reaching out — we’ve received your message and will get back to you shortly!',
  icon: 'success',
  confirmButtonText: 'Awesome!',
  confirmButtonColor: '#FD5F20',
});


      setFormData({ 
        name: '', 
        email: '', 
        phone: '', 
        budget: '', 
        company: '', 
        metrics: '', 
        message: '' 
      });
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: error.response?.data?.error || 'An error occurred while sending your message.',
        icon: 'error',
        confirmButtonText: 'Try again',
        confirmButtonColor: '#FD5F20',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  return (
    <>
      <HeadComponent/>
      <div className="max-w-7xl min-h-auto mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col lg:flex-row gap-12">
          {/* Left Content */}
          <motion.div 
            className='flex-1'
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="mb-8">
              <motion.h1 
                className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-6 text-gray-900"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
              >
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-800 to-gray-600">
                 Would You Like to Start a Project with Us?
                </span>
              </motion.h1>
              
              <motion.p 
                className='text-lg text-gray-600 leading-relaxed'
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                Discover and define the essential qualities and values of your brand with the help of our expert team.
                 Our experienced professionals will collaborate closely with you to uncover the true essence of your brand,
                  enabling you to understand and communicate its unique identity to your audience more effectively.
                 Let us assist you in unlocking the full potential of your brand through our thorough discovery process.
              </motion.p>
            </div>

          
          </motion.div>

          {/* Right Form */}
          <motion.div 
            className='flex-1'
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <motion.div 
              className=" rounded-xl  p-6 sm:p-8 border border-gray-100"
              whileHover={{ y: -5 }}
              transition={{ duration: 0.3 }}
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6">Contact Us</h2>
              
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="w-full px-4 py-3 rounded-lg border-2 border-[#FD5F20]/80 focus:border-[#FD5F20] focus:ring-2 focus:ring-[#FD5F20]/20 transition-all placeholder-gray-500"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  
                  <div>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      className="w-full px-4 py-3 rounded-lg border-2 border-[#FD5F20]/80 focus:border-[#FD5F20] focus:ring-2 focus:ring-[#FD5F20]/20 transition-all placeholder-gray-500"
                      placeholder="Phone Number"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  
                  <div className="relative">
                    <select
                      id="budget"
                      name="budget"
                      className="w-full px-4 py-3 rounded-lg border-2 border-[#FD5F20]/80 focus:border-[#FD5F20] focus:ring-2 focus:ring-[#FD5F20]/20 appearance-none bg-white pr-10 transition-all text-gray-900"
                      value={formData.budget}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled hidden className="text-gray-500">Select Budget</option>
                      <option value=">5k"> &lt;5k </option>
                      <option value="5k-10k">5k - 10k</option>
                      <option value="10k-20k">10k - 20k</option>
                      <option value="20k-30k">20k - 30k</option>
                      <option value="30k-40k">30k - 40k</option>
                      <option value="50k+">50k+</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pt-5 pointer-events-none text-[#FD5F20]">
                      <FontAwesomeIcon icon={faChevronDown} />
                    </div>
                  </div>
                  
                  <div>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      className="w-full px-4 py-3 rounded-lg border-2 border-[#FD5F20]/80 focus:border-[#FD5F20] focus:ring-2 focus:ring-[#FD5F20]/20 transition-all placeholder-gray-500"
                      placeholder="Company Name"
                      value={formData.company}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  
                  <div>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="w-full px-4 py-3 rounded-lg border-2 border-[#FD5F20]/80 focus:border-[#FD5F20] focus:ring-2 focus:ring-[#FD5F20]/20 transition-all placeholder-gray-500"
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  
                  <div className="relative">
                    <select
                      id="metrics"
                      name="metrics"
                      className="w-full px-4 py-3 rounded-lg border-2 border-[#FD5F20]/80 focus:border-[#FD5F20] focus:ring-2 focus:ring-[#FD5F20]/20 appearance-none bg-white pr-10 transition-all text-gray-900"
                      value={formData.metrics}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled hidden className="text-gray-500">Preferred Contact Method</option>
                      <option value="video-call">Video Call</option>
                      <option value="phone-call">Phone Call</option>
                      <option value="face-to-face">Face-to-Face Meeting</option>
                      <option value="email">Email</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pt-5 pointer-events-none text-[#FD5F20]">
                      <FontAwesomeIcon icon={faChevronDown} />
                    </div>
                  </div>
                </div>

                <div>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    className="w-full px-4 py-3 rounded-lg border-2 border-[#FD5F20]/80 focus:border-[#FD5F20] focus:ring-2 focus:ring-[#FD5F20]/20 transition-all placeholder-gray-500"
                    placeholder="Tell us about your project..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                <motion.button
                  type="submit"
                  className="w-full bg-gradient-to-r from-[#FD5F20] to-[#FF8C00] text-white font-semibold py-4 px-6 rounded-lg  hover: transition-all duration-300 flex items-center justify-center"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <span className="flex items-center">
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Processing...
                    </span>
                  ) : (
                    <span className="flex items-center">
                      <FontAwesomeIcon icon={faPaperPlane} className="mr-2" />
                      Submit Request
                    </span>
                  )}
                </motion.button>
              </form>
            </motion.div>
          </motion.div>
        </div>

        {/* Modal */}
        {modalVisible && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
            <motion.div 
              className={`bg-white rounded-xl  p-6 w-full max-w-md relative ${isSuccess ? 'border-t-4 border-green-500' : 'border-t-4 border-red-500'}`}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
            >
              <button 
                onClick={closeModal}
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              
              <div className="text-center">
                <div className={`mx-auto flex items-center justify-center h-12 w-12 rounded-full ${isSuccess ? 'bg-green-100' : 'bg-red-100'}`}>
                  {isSuccess ? (
                    <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  ) : (
                    <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  )}
                </div>
                <h3 className={`mt-3 text-lg font-medium ${isSuccess ? 'text-green-800' : 'text-red-800'}`}>
                  {isSuccess ? 'Success!' : 'Oops!'}
                </h3>
                <div className="mt-2">
                  <p className={`text-sm ${isSuccess ? 'text-green-600' : 'text-red-600'}`}>
                    {responseMessage}
                  </p>
                </div>
                <div className="mt-5">
                  <button
                    type="button"
                    className={`px-4 py-2 rounded-md text-white ${isSuccess ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'} focus:outline-none transition-colors`}
                    onClick={closeModal}
                  >
                    Got it, thanks!
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </div>
    </>
  );
};

export default ContactForm;